var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMvideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#ED1C24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2109 14.1436C16.2109 14.4994 15.9222 14.788 15.5665 14.788C15.2108 14.788 14.9226 14.4994 14.9226 14.1436C14.9226 13.7879 15.2108 13.4998 15.5665 13.4998C15.9222 13.4998 16.2109 13.7879 16.2109 14.1436Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48328 14.4989C6.7239 13.6964 7.3145 12.219 7.44185 10.9103C7.27263 11.0793 5.58384 15.0052 4.06406 14.8356C2.71328 14.4145 2.88207 12.8942 3.30417 11.7546H5.49909C4.82374 13.6117 5.75241 12.852 6.38582 11.6702C7.65228 9.09515 7.73682 8.88421 9.12998 5C9.93196 5 10.7338 5 11.5363 5C10.8188 7.19543 10.143 9.3484 9.84793 11.6279C9.84793 11.7122 9.88987 11.7967 9.97441 11.7546C10.4806 11.6702 13.2671 5.42268 13.5202 5C14.2381 5 15.0825 5 15.8418 5C15.8418 5.21109 13.2671 12.2611 13.6893 12.9363C13.9006 13.3162 14.1963 12.5989 14.4491 12.3031L14.8295 12.6832C14.0696 13.5279 13.1833 15.047 11.9166 14.794C11.7476 14.7517 11.5787 14.6679 11.4524 14.5408C10.143 13.4012 12.5073 9.28103 12.2544 9.01062C12.1757 9.01938 12.097 9.2288 11.9585 9.51704C11.2405 10.9948 9.59497 14.8784 8.24317 14.8784C8.03252 14.8784 7.60976 14.6678 7.48328 14.4989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvideo);
export default __webpack_public_path__ + "static/media/mvideo.50387265fcb57a435263688557a7e666.svg";
export { ForwardRef as ReactComponent };